module.exports = __webpack_public_path__ + "static/media/belfast-lose.c57289ef.png";